import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

const IMG_PILE =
  "https://images.unsplash.com/photo-1617303331806-3d6b58e03241?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxpcm9uJTIwbWV0YWwlMjBzY3JhcCUyMGR1bXB8ZW58MHx8fHwxNzg4MTA5NTI5fDA&ixlib=rb-4.1.0&q=85";

const cols = [
  {
    title: "We Buy",
    items: ["Iron & MS scrap", "Plastic scrap", "Vehicle scrap — cars, bikes, commercial", "Demolition & factory clearance lots"],
    note: "Bring it to the yard or call us for pickup on bulk lots. Weighed in front of you, paid on the spot.",
    testid: "scrap-we-buy",
  },
  {
    title: "We Sell",
    items: ["Sorted iron scrap by grade", "Reusable steel sections", "Plastic scrap lots", "Vehicle scrap & parts metal"],
    note: "Clean, sorted and graded stock ready for foundries, fabricators and recyclers.",
    testid: "scrap-we-sell",
  },
];

export default function BuySell() {
  return (
    <section id="scrap" className="border-b border-[#262626]" data-testid="scrap-section">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative min-h-[420px] lg:min-h-full overflow-hidden group">
          <img
            src={IMG_PILE}
            alt="Industrial scrap metal yard"
            className="spotlight-img absolute inset-0 w-full h-full object-cover opacity-60"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#050505]/80" />
          <div className="relative p-8 md:p-12 flex flex-col justify-end h-full min-h-[420px]">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="font-display text-4xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] tracking-tight text-steel"
            >
              Scrap.
              <br />
              Both Ways.
            </motion.h2>
          </div>
        </div>

        <div className="grid grid-cols-1 divide-y divide-[#262626] border-t lg:border-t-0 lg:border-l border-[#262626]">
          {cols.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="p-8 md:p-12"
              data-testid={c.testid}
            >
              <h3 className="font-display text-2xl sm:text-3xl uppercase text-steel-soft mb-6">{c.title}</h3>
              <ul className="space-y-2 mb-6">
                {c.items.map((it) => (
                  <li key={it} className="text-sm text-[#a3a3a3] flex items-start gap-3">
                    <span className="text-[#525252]">—</span> {it}
                  </li>
                ))}
              </ul>
              <p className="text-xs text-[#737373] leading-relaxed mb-6">{c.note}</p>
              <button
                onClick={() => scrollToSection("#quote")}
                className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#f5f5f5] border border-[#3f3f3f] px-5 py-3 hover:bg-[#f5f5f5] hover:text-[#050505] transition-colors duration-300"
                data-testid={`${c.testid}-quote-button`}
              >
                Get a rate <ArrowRight size={14} />
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
